import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { firstValueFrom } from 'rxjs';
import { SidebarControlModeService } from '../../../sidebar-control-mode.service';

@Component({
  selector: 'app-home-mode-end-date-edition',
  templateUrl: './home-mode-end-date-edition.component.html',
  styleUrls: ['./home-mode-end-date-edition.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeModeEndDateEditionComponent {

  UNTIL_CHANGED_INDEX = 0;
  END_TIME_INDEX = 1;

  selectedIndex = signal(0);

  constructor(
    private homesFacade: HomesFacade,
    public controlModeService: SidebarControlModeService,
  ) { }

  async ngAfterViewInit() {
    this.homesFacade.currentHomeId$.pipe(isDefined()).subscribe(async () => {
      const endDate = await firstValueFrom(this.homesFacade.currentModeEndTime$);
      if (endDate) {
        this.selectedIndex.set(this.END_TIME_INDEX);
      }
      else {
        this.selectedIndex.set(this.UNTIL_CHANGED_INDEX);
      }
    });

    this.controlModeService.selectMode$.subscribe(() => {
      this.selectedIndex.set(this.UNTIL_CHANGED_INDEX);
    });
  }

  async selectUntilChanged() {
    this.selectedIndex.set(this.UNTIL_CHANGED_INDEX);
    const thermMode = await firstValueFrom(this.homesFacade.thermMode$);
    const homeId = await firstValueFrom(this.homesFacade.currentHomeId$);
    this.homesFacade.changeThermHomeMode(homeId, thermMode);
  }

  selectEndDate() {
    this.selectedIndex.set(this.END_TIME_INDEX);
  }

}
